"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccount = getAccount;

var _axios = _interopRequireDefault(require("axios"));

var _axiosRetry = _interopRequireDefault(require("axios-retry"));

var _axiosRetryPolicy = require("./axiosRetryPolicy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAccount(accessToken, accountId) {
  const client = _axios.default.create();

  (0, _axiosRetry.default)(client, _axiosRetryPolicy.standardRetryPolicy);
  return client.get(`/api/v1/accounts/${accountId}`, {
    baseURL: 'https://accounts.cimpress.io',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }).then(response => response.data).catch(err => {
    throw err;
  });
}